import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Link,
  Typography as MuiTypography,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { NavLink, useParams } from "react-router-dom";

import BasicWaterQualityParametersInfo from "./BasicWaterQualityParametersInfo";
import { useStateIfMounted } from "use-state-if-mounted";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Typography = styled(MuiTypography)(spacing);

function WaterQualityParameterManagement() {
  let { id } = useParams();
  const [selectedWaterQualityParameter, setSelectedWaterQualityParameter] =
    useStateIfMounted(id);

  return (
    <React.Fragment>
      <Helmet title="Edit Water Quality Parameter" />
      <Typography variant="h3" gutterBottom display="inline">
        Edit Water Quality Parameter
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Link
          component={NavLink}
          exact
          to="/data-management/manage-lists/water-quality-parameters"
        >
          Water Quality Parameters
        </Link>
        <Typography>Edit Water Quality Parameter</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <BasicWaterQualityParametersInfo
        selectedWaterQualityParameter={selectedWaterQualityParameter}
        setSelectedWaterQualityParameter={setSelectedWaterQualityParameter}
        isEditMode={true}
      />
    </React.Fragment>
  );
}

export default WaterQualityParameterManagement;
